import { createContext } from 'react';

/**
 * @todo perform actions that determine whether user
 * is in native app or web when creating the context.
 */

function getEnvironmentType() {
  // if the developer is 'mocking' their own environment type accept that over everything.
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_MOCK_ENV === true) {
    return process.env.REACT_APP_MOCK_ENV_TYPE || 'web';
  }

  // otherwise, run environment detection

  // currently we'll just return web. But for native (in-app browser) apps we'll return 'native'.
  return 'web';
}

/**
 * @todo I don't believe this is used anywhere – KW 26/3/2024
 */
const EnvironmentContext = createContext({
  env: getEnvironmentType(),
  auth: {}, // assuming we may be given an auth token from a native app
  session: {} // assuming their might be additional (marketing?) session parameters...
});

EnvironmentContext.displayName = 'Environment';

export { EnvironmentContext };
